import React, { Component } from 'react'
import styled from 'styled-components'
import Scroll from '../../components/Scroll'
import Collapse, { Panel } from 'rc-collapse'
import TimeAgo from 'react-timeago'
import 'rc-collapse/assets/index.css'
const moment = require('moment')

const SessionId = styled.p`
    width: 30%;
    float: left;
    margin: 0px -12px 0px 0px;
`
class ActionLog extends Component {
  state = {
    items: []
  }

  componentDidMount() {
    const botSessions = sessionStorage.getItem('bot_sessions')
    this.setState({
      items: (botSessions && JSON.parse(botSessions)) || []
    })
  }

  renderItem = (item, index) => {
    const formatted = moment(item.timestamp).format('lll')
    const sessions = this.state.items.length

    return (

      <Panel header={<div style={{ width: '92%', float: 'right', color: 'var(--clr-grey-1-to-white, #f9f9f9)' }}>
        <SessionId>{`Session ${sessions - index},`}</SessionId><TimeAgo date={formatted} /></div>} >
        {item.actions.map(action => (
          <div key={action.timestamp}>
            <div>
              <span><b>{action.sender}</b> ({moment(action.timestamp).format('LT')}): </span>
              <span dangerouslySetInnerHTML={{ __html: action.msg }} />
            </div>
            <hr />
          </div>
        ))}

        {item.notes && item.notes.length > 0 && (
          <div>
            <span><b>Notes taken: </b></span>
            <span
              dangerouslySetInnerHTML={{ __html: item.notes.join('<br/>').replace(/(?:\r\n|\r|\n)/g, '<br/>') }} />
          </div>
        )}
      </Panel>
    )
  }

  render() {
    const items = this.state.items.map((item, index) => this.renderItem(item, index))
    return (
      <Scroll style={{ height: '100%' }}>
        <Collapse defaultActiveKey={'0'}>
          {items}
        </Collapse>
      </Scroll>
    )
  }
}

export default ActionLog



// WEBPACK FOOTER //
// ./src/ChatWidget/components/ActionLog/index.js